export default "__VITE_ASSET__DL9D5ZMX__"